import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * REEMISSÃO (segunda via) — migração de Boletim e Ficha > Reemissão (`EmitirBoletimSegundaVia.aspx`).
 * Permissão PRÓPRIA (300500599), vizinha da legada 300500500 — ver CLAUDE.md, "Permissão de tela nova".
 */
export default [
  {
    description: 'Reemissão de Documentos',
    path: '/academico/reemissao',
    name: 'reemissao-documentos',
    component: () => import('@/views/academico/reemissao/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.REEMISSAONOVO_MENU_300500599],
    },
    goesToMenu: true,
  },
];
